import { IDadosCriarLote } from "../interfaces/IDadosCriarLote";

export const defaultDadosCriarLote: IDadosCriarLote = {
  tipo: "bloquear",
  empresa: 0,
  nomeEmpresa: "",
  divisao: 0,
  nomeDivisao: "",
  centroCusto: 0,
  nomeCentroCusto: "",
  solicitante: 0,
  nomeSolicitante: "",
  cnpj: "",
  arquivo: null,
};
